import { QRCodeBox } from '@/components/DataDisplay';
import { ButtonPrimary } from '@/components/Form';
import { Copy } from '@/components/Icon';
import Modal from '@/components/Modal';
import { Body, Heading, Headline, Text } from '@/components/Typography';
import { colors } from '@/styles/theme/constants';
import { copyToClipboard } from '@/utility/dom';
import { Box, Flex, HStack, Link, Stack } from '@chakra-ui/react';
import { useCallback, type FC } from 'react';
import { useSetupTwoFAStore } from '../useSetupTwoFAStore';
import type { QRCodeStepProps } from './types';

const INSTRUCTIONS = [
  <>
    Download Google Authenticator di ponselmu dari{' '}
      <Link color="blue.500" href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank">App Store</Link> atau{' '}
      <Link color="blue.500" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">Google Play</Link>
  </>,
  <>
    Buka Google Authenticator, tap tombol <b>(+)</b> dan pilih <b>Masukkan kode</b> atau <b>Scan kode QR</b>
  </>,
  <>
    Scan QR atau salin Kode di bawah dan masukkan ke aplikasi autentikator.
  </>
];

const QRCodeStep: FC<QRCodeStepProps> = ({ onNext  }) => {
  const code = useSetupTwoFAStore((s) => s.qrCode);
  const secretCode = useSetupTwoFAStore((s) => s.secretCode);

  const handleCopySecretCode = useCallback(() => {
    if (!secretCode) return;
    
    copyToClipboard(secretCode);
  }, [secretCode]);

  return (
    <Modal
      disabled
      data-testid="modal_setup2fa_qrCode"
      onClose={() => {}}
      isOpen
      noMaxHeight={true}
      maxWidth={'327px'}
      noHeader
      hasCloseButton={false}
    >
      <Heading variant="Bold18" color="darkWillow" mb="24px">
        Pasang Autentikasi 2 Lapis
      </Heading>
      <Stack spacing="16px">
        {INSTRUCTIONS.map((item, index) => (
          <HStack align="start" key={index}>
            <Headline
              variant="Bold" 
              color="white" 
              fontSize="12px" 
              letterSpacing="1.2px" 
              textTransform="uppercase"
              bgColor="red03"
              px="5px"
              py="2px"
              borderRadius="4px"
              mt="3px"
            >
              {index + 1}
            </Headline>
            <Body variant="Default14" color="shade03">{item}</Body>
          </HStack>
        ))}
        {code && (
          <Box display="flex" justifyContent="center">
            <QRCodeBox data={code} />
          </Box>
        )}
        <Text fontSize="14px" fontWeight="800" lineHeight="20px" textTransform="uppercase" color="shade03" textAlign="center">
          {secretCode}
        </Text>
        <Flex as="button" gap="8px" justify="center" align="center" cursor="pointer" onClick={handleCopySecretCode}>
          <Copy fill={colors.red03} />
          <Text fontSize="14px" fontWeight={700} lineHeight="20px" color="red03">Salin Kode</Text>
        </Flex>
      </Stack>
      <Box textAlign="center" mt="24px">
        <ButtonPrimary width="100%" onClick={onNext}>
          Selanjutnya
        </ButtonPrimary>
      </Box>
    </Modal>
  )
}

export default QRCodeStep;
